import Images from "./ImageImports.js"


export const COMPONENT_DATA = {
  "Blotting Paper": Images.Blotting_Paper,
  "CellSpreader": Images.CellSpreader,
  "Chromatography": Images.ChromatographyColumn,
  "Flask": Images.OneX_Sodium_Borate_Buffer,
  "Floating Tube Rack": Images.floatingTubeRack,
  "Freezer": Images.freezer_closed,
  "Gel": Images.Agarose_Gel,
  "Gel Box": Images.Gel_Electrophoresis_Box,
  "Ice Bucket": Images.IceBucket,
  "Incubator": Images.Incubator,
  "LabTape": Images.LabTape,
  "Microcentrifuge": Images.Microcentrifuge,
  "Petridish": {
    "LB": Images.petridishLB,
    "LB/amp": Images.petridishLBAMP,
    "LB/amp/ara": Images.petridishLBAMPARA,
  },
  "Pipette": {
    "P2": Images.P2_Pipette,
    "P20": Images.P20_Pipette,
    "P200": Images.P200_Pipette,
    "P1000": Images.P1000_Pipette,
  },
  "Solution": {
    "Binding" : Images.SolutionFalconBB,
    "ColumnEquilibrationBuffer" : Images.SolutionFalconCEB,
    "Elution" : Images.SolutionFalconEB,
    "Wash" : Images.SolutionFalconWB,
  },
  "Power Supply": Images.Power_Supply,
  "Power Supply Lead": Images.Power_Supply_Leads,
  "Tip Box": {
    "P2": Images.P2_Tip_Box,
    "P20": Images.P20_Tip_Box,
    "P200": Images.P200_Tip_Box,
    "P1000": Images.P1000_Tip_Box,
  },
  "Trash": {
    "Trash": Images.Trash,
    "Biohazard": Images.Biohazardous,
  },
  "Vortex": Images.Vortex,
  "Water Bath": Images.WaterBath,
  "Waste Collection Jar": Images.WasteCollectionJar,
  "Timer": Images.Timer,
};

export function getImageData (component, props) {
  switch (COMPONENT_DATA[component] instanceof Object) {
    default:
      return COMPONENT_DATA[component][props.type]
    case false:
      return COMPONENT_DATA[component]
  }
}
